const data = [
  {
    catogeries: "phone",
    id: "1",
    name: "APPLE iPhone 12 Pro (Gold, 128 GB)",
    rating: "4.5",
    discription:
      "A14 Bionic rockets past every other smartphone chip. The Pro camera system takes low-light photography to the next level — with an even bigger jump on iPhone 12 Pro Max. And Ceramic Shield delivers four times better drop performance. Let’s see what this thing can do.",
    price: "₹119900",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbr37gm57f7.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrnpyygbv9.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrpksqr8zu.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrgcctfysm.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrqwsxbmuh.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content.",
      "One of the best looking phone in the market right now with a decent performance jump from 11 pro. Camera is excellent and the display is quite responsive and sharp. Only issue is it does not have a higher refresh rate and the battery life is average.",
      "I have upgraded from Android to iOS for the first time with the IPhone 12 Pro. And the experience is very much satisfactory. The new A14 bionic processor is very fast. The boxy design is what I liked the most. The camera and display are top notch. Night mode photography is excellent. Worth upgrading from Android to iOS .",
      "Awesome! Just made an upgrade from X, worth every single penny spent on it, the camera is just too superb, be it the selfie cam or the main rear cam, the goodness it takes the picture is just beyond words, no smart phone can beat it atm! However, the battery life tends to be on the shorter side, that’s the only con that I can’t think up of now.",
    ],
    quantity: 1,
  },

  {
    catogeries: "phone",
    id: "2",
    name: "realme Narzo 30 5G (Racing Blue, 128 GB)",
    rating: "4.5",
    discription:
      "High-speed internet, smooth gaming, and stunning photos, the realme Narzo Pro 5G is a power-packed smartphone for impressive performance. This smartphone features the 5G Technology for high-speed web browsing, the Dimensity 700 5G Processor for smooth gaming, and a 5000 mAh Massive Battery for hours of uninterrupted performance.",
    price: "₹15,990",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/d/l/f/narzo-30-5g-rmx3242-realme-original-imag45yjdkgxddvh.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/8/u/w/narzo-30-5g-rmx3242-realme-original-imag45yjxdvfkrws.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/j/s/o/narzo-30-5g-rmx3242-realme-original-imag45yjnhhqy4gv.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/o/l/w/narzo-30-5g-rmx3242-realme-original-imag45yjxqhvfzjn.jpeg?q=70",
    ],
    review: [
      `First the phone design is awesome. And in this price it is the best 6gb ram 5G phone.
      Pros:
      1. Good battery life
      2. Smooth refresh rate
      3. Design
      4. Additional ram of 5gb features
      5. 5G phone with most number of bands in India ri8 now.
      
      
      Cons:
      1. Display LCD not up to the mark
      2. Camera is better but ok
      3. 18W charger`,
      "Really great phone , it's worth for money , good display , good battery backup , really a good phone ❤️👏👍",
      `super camera qulity...i use realme phon first time but i m feel so much happy and satisfaide with product..

      battery life is good and phon work also fast...
      
      and specily thenks to flipcart..`,
    ],
    quantity: 1,
  },

  {
    catogeries: "phone",
    id: "3",
    name: "POCO M3 (Power Black, 64 GB)",
    rating: "4.5",
    discription:
      "High-speed internet, smooth gaming, and stunning photos, the realme Narzo Pro 5G is a power-packed smartphone for impressive performance. This smartphone features the 5G Technology for high-speed web browsing, the Dimensity 700 5G Processor for smooth gaming, and a 5000 mAh Massive Battery for hours of uninterrupted performance.",
    price: "₹11,499",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kklhbbk0/mobile/m/s/f/m3-mzb0879in-poco-original-imafzxf686qtxq2x.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kkoc70w0/mobile/l/5/5/m3-mzb0879in-poco-original-imafzyx8dkyvjyt5.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kklhbbk0/mobile/w/k/2/m3-mzb0879in-poco-original-imafzxf65mefhdrr.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kklhbbk0/mobile/e/e/d/m3-mzb0879in-poco-original-imafzxf6e5mvhqpm.jpeg?q=70",
    ],
    review: [
      `Good mobile poco m3
      Pros:
      Fullhd display,
      smooth tocuh response,
      6000mah battery,
      avarage weight,
      back disign amazing,
      no heatting issue,
      decent back camera
      Excellent sound quality it's very clear
      Cons:
      front camara not take a clear picture,
      Charging time to long .50% charging time 1 hour 35 minutes.
      Ovarall the price segment this mobile good`,
      "Sound quality super 3 type sound but camera selfie camera is not good &Back camera is normally or value of money. Totally side & angel to seen to parfect",
      `One word review " Value for Money"
      It has the potential to be a nice casual daily driver
      Speakers are loud...like seriously loud.
      Screen size is good
      Though being a LCD screen it produces decent colours. For the price at which it comes that more than enough.
      Camera is neither the best nor the worst, it's quite good for this price point.
      6000 mA battery 🔋👍🏻
      Though it comes with a lot of bloatware but you can just uninstall most of them (excluding system apps)
      Finally the Verdict is that it's a good budget smartphone`,
    ],
    quantity: 1,
  },

  {
    catogeries: "phone",
    id: "4",
    name: "MOTOROLA G60 (Dynamic Gray, 128 GB)",
    rating: "4.5",
    discription:
      "The moto g60 enables you to capture spectacular selfies wherever you are, thanks to its 32 MP selfie camera, the Quad Pixel technology, and LED flash. Thanks to the smooth 17.2 cm (6.8) HDR10 Display, you can enjoy a lifelike experience while streaming content, gaming, and more. And, thanks to the powerful 6000 mAh battery, you can enjoy using your mobile phone for all that you need, without any low-battery interruptions for a long time.",
    price: "₹17,999",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/knoxnrk0/mobile/g/1/j/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag2aq9v8hzetbn.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kolsscw0/mobile/u/o/z/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag3f57r8v8p7q5.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knoxnrk0/mobile/h/c/a/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag2aq9j5czsghh.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knoxnrk0/mobile/i/5/z/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag2aq9zhcmnnym.jpeg?q=70",
    ],
    review: [
      `1.Very Smooth user interface.
      2. Gives you easily Two Days of battery backup with average use.
      3. Hepatic feedback too good.
      4. In this price range Rear camera is Above average. Hope it should be improve in future updates. & Front camera perform very well.
      5. In hand feel is little bulky, it feel heavier than other phone due to its big 6000 mah battery
      6. Display size is very big ( 6.8 inches ) & bright.
      7. Voice call quality is very good & clear.
      8. Notification LED light is missing, but Previous Motorola phones have led notification light.
      9. You will definitely love the gesture controls of this phone.
      10. It is splash proof & water repellent design.
      
      Over all this phone is value for money
      Go for it ...`,
      "Best phone in budget. Working very smoothly. Touch quality is awesome. Display is also very nice. Battery of the phone is very good only camera part is not so good as expected some updates are needed in camera rest all the things are the best.",
      `Product is worth of money. Performance of this is very smooth. I love it usually m using Motorola smart phone but this one is best.`,
    ],
    quantity: 1,
  },

  {
    catogeries: "phone",
    id: "5",
    name: "Mi 11X (Lunar White, 128 GB)",
    rating: "4.2",
    discription:
      "The Mi 11X from Xiaomi is the most affordable of three new models in the Mi 11 family. It's priced a bit lower than the Mi 10T but offers plenty of updated features, most notably its Qualcomm Snapdragon 870 SoC which is only one step below the current flagship level. ",
    price: "₹27,990",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kp78e4w0/mobile/b/2/u/11x-11x-mi-original-imag3hqsshfzpv4u.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/mobile/0/t/7/m2012k11ai-11x-redmi-original-imag2qsbpgar8sfd.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kod858w0/mobile/0/m/5/11x-pro-11x-pro-mi-original-imag2tzmhwzmf66y.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/mobile/o/4/b/m2012k11ai-11x-redmi-original-imag2qsbpbk6vyg3.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content. ",
      "I say about this mobile only wow wow and wow it's performing god level performance and this mobile look so cool very slim and light weight mobile display quality is 10/10 battery life is so better it's battery perform like 6000 mah of ips display mobile amoled is very good working Iblove it❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️😍😍😍😍",
      "Good phone...But not a good camera..Usually redmi phones not good in camera quality but it's ok...120 heartz refresh rate with AMO LED display give perfect display and best batter backup",
    ],
    quantity: 1,
  }, {
    catogeries: "phone",
    name: "OPPO Reno6 Pro 5G (Aurora, 256 GB)",
    id: "6",
    rating: "4.5",
    discription:
      "The OPPO Reno6 Pro 5G is not only easy on the eyes but also equipped with innovative features. The X-axis Linear Motor ensures immersive viewing and usage. With an ultra-slim body and lightweight construction, you can easily hold it during extended usage. You can replicate the appeal of some of your favourite images in a single click with the AI Palette feature. And, you can enjoy long-lasting usage with its 4500 mAh battery.",
    price: "₹55,900",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/l/p/k/reno6-pro-5g-cph2249-oppo-original-imag4xpc6mc62mzq.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/k/u/u/reno6-pro-5g-cph2249-oppo-original-imag4xpcvxzzyzgz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/i/c/l/reno6-pro-5g-cph2249-oppo-original-imag4xpchmrsqdru.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/r/h/1/reno6-pro-5g-cph2249-oppo-original-imag4xpcbhkmzecp.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content.",
      `It's a marvel from Oppo.. Stellar black one is just superb and the device is an all-rounder. Stunning looks and superb performance.
    Pros:
    Great looks
    Stunning curved oled display
    Great rear cams
    Super speed and smooth performance
    Dolby Atmos sound clarity is perfect
    Superb Call clarity and network reception
    In hand feel is supercool
    Ultrafast charging`,
      "This is a Great phone, nice camera, Good Battery backup, Fast Charging and beautiful design. I Love 😘😘 it",
    ],
    quantity: 1,
  },
  {
    catogeries: "phone",
    id: "7",
    name: "realme 8 Pro (Infinite Black, 128 GB)",
    rating: "4.2",
    discription:
      "The realme 8 Pro features a Tilt-shift mode and the Tilt-shift Time Lapse video so that you can add a creative perspective to the content that you create. Thanks to the Super AMOLED Display, your favourite movies, games, and more are more bright and vivid on screen. And, thanks to the 4500 mAh battery, you can stream content, game, and more without worrying about recharging your phone.",
    price: "₹19,999",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/5/w/u/8-pro-rmx3081-realme-original-imagfgpgcxyjufz3.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/i/5/l/8-pro-rmx3081-realme-original-imagfgpgecfv3rng.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/e/z/b/8-pro-rmx3081-realme-original-imagfgpgvnmggnzd.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/u/z/r/8-pro-rmx3081-realme-original-imagfgpgedksupyf.jpeg?q=70",
    ],
    review: [
      "Old concept... realme 7 pro has same 720 g processor .yes 720g is very capable but using it again and again is not good but yes camera is very good even in 20x zoom images are super good and one thing more narzo 30 pro has 5g connectivity but this hadnt so ya 5g should be there",
      "Not a worth buy considering the competetions. A 90hz refresh rate and 732g processor would have given a better competetion and decent buy!!",
      "Super Mobile. I like so much. RAM is good. Camera is amazing. Battery charging speed excellent. Within 45min it will be full from 10% of battery. Only thing, the battery came down little fastly. It's not coming one day with Internet. With internet it's coming around 12 to 15 hrs. Totally very super mobile.",
    ],
    quantity: 1,
  },

  {
    catogeries: "phone",
    id: "9",
    name: "SAMSUNG Galaxy A52 (Awesome Blue, 128 GB)",
    rating: "4.3",
    discription:
      "Bring home the Samsung Galaxy A52 smartphone to enjoy viewing sharp visuals, click clear images, record stable videos, and do more. Its rear camera setup, with OIS, helps you capture clear shots. While its 16.40 cm (6.5) FHD+ Super AMOLED display delivers vivid visuals, the Eye Comfort Shield ensures reduced blue light emissions, thereby preventing eye strain.",
    price: "₹27,999",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/s/z/a/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xdvtk8zzb.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/1/r/s/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xs5wtfmpm.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/s/d/i/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xyymq9gjw.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/t/0/n/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xczdhwwjn.jpeg?q=70",
    ],
    review: [
      "Good one. Nice camera. battery will last for a day. Good network reception. Update after 7 days of usage: Absolutely great phone. The camera great.",
      "Loved the design, quality, performance, feels rich while handling, and really appreciate that samsung had improved a lot for the user experience. E.g. performance, battery management has been improved a lot. Feels premium device. Easy and Smooth interface. I loved 😍it and would recommend to my friends and family!",
      "Finally Samsung brings an updated version of Galaxy A series which was one of the most selling mobile last year. As of now performance wise it's very much impressive. A52 feels good in hand and looks premium. No lag,display & camera quality is very good on this price category. Forget about Pixel and One plus here is the 8 GB varient which is definitely a value for money product 💯🤘",
    ],
    quantity: 1,
  },

  {
    catogeries: "phone",
    id: "10",
    name: "SAMSUNG Galaxy F12 (Celestial Black, 64 GB)",
    rating: "4.5",
    discription:
      "The Samsung Galaxy F12 features a stylish design and innovative features so that you can enjoy using the mobile phone for all that you need. Thanks to its 6000 mAh battery, you will have a blast using your phone for a long time while you stream content and much more. It provides surround sound with Dolby Atmos so that you can delve into a world of rich music. And, it’s equipped with features that ensure the protection of your mobile phone.",
    price: "₹20900",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kn22m4w0/mobile/6/o/e/galaxy-f12-sm-f127gzkgins-samsung-original-imagftmhuqq3arbg.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kn22m4w0/mobile/l/y/w/galaxy-f12-sm-f127gzkgins-samsung-original-imagftmhwjx38zzs.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kn22m4w0/mobile/h/y/s/galaxy-f12-sm-f127gzkgins-samsung-original-imagftmhhvhmeqyb.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content. ",
      "Best Samsung phone in this price range.Good battery back up.Decent Display.Fast fingerprint sensor.Rear camera quality is good.front camera is not up to the mark.90 Hz refresh rate is good.Good user interface.updated to one ui 3.1.there are some pre installed apps which can only be disabled.sound quality is low comparing with other smartphones in same price segment.using in low screen bightness noticed screen flickering.",
      "First I would like to thank you Flipkart for fastest delivery and yah the delivery guy is so cooperative and helpful. Samsung phones are always best in performance and this one is also affordable and awesome phone",
    ],
    quantity: 1,
  },

];

export default data;
